export default __webpack_public_path__ + "static/media/edit-new-icon.40631bfa.svg";